import React, { createContext, useContext, useMemo } from 'react';

export const PollingContext = createContext(null);

export const PollingContextProvider = ({ startPolling, stopPolling, children }) => {
    const startPollingMemoized = useMemo(() => startPolling, []);
    const stopPollingMemoized = useMemo(() => stopPolling, []);

    return (
        <PollingContext.Provider value={{ startPolling: startPollingMemoized, stopPolling: stopPollingMemoized }}>
            {children}
        </PollingContext.Provider>
    );
};

export const usePollingContext = () => {
    const context = useContext(PollingContext);
    if (!context) {
        throw new Error('usePollingContext must be used within an PollingContextProvider');
    }

    return context;
};
